export const ThreeDots = (): JSX.Element => (
  <svg width="21" height="5" viewBox="0 0 21 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="17.749" cy="2.5" r="2.5" transform="rotate(90 17.749 2.5)" fill="#6CC2FF" />
    <circle cx="10.3157" cy="2.5" r="2.5" transform="rotate(90 10.3157 2.5)" fill="#6CC2FF" />
    <circle cx="2.5" cy="2.5" r="2.5" transform="rotate(90 2.5 2.5)" fill="#6CC2FF" />
  </svg>
);
